import L from 'leaflet';
import { withLeaflet, MapControl, MapControlProps } from 'react-leaflet';
import Locate from 'leaflet.locatecontrol';
import 'leaflet.locatecontrol/dist/L.Control.Locate.min.css';

// import './Geolocate.css';
//@ts-ignore
type GeolocateProps = L.Control.LocateOptions & MapControlProps;

class Geolocate extends MapControl<GeolocateProps> {
    createLeafletElement(props: GeolocateProps) {
        const { leaflet, ...options } = props;
        const locate = Locate as any;
        const lc = new locate(options);
        return lc;
    }
}
export default withLeaflet(Geolocate);